<form [formGroup]="myGroup" #addUserForm id="myForm" novalidate (ngSubmit)="onSubmit($event)">
	<section id="content">
		<div class="spinner-container">
			<div class="spinner">
				<div class="sk-folding-cube">
					<div class="sk-cube1 sk-cube"></div>
					<div class="sk-cube2 sk-cube"></div>
					<div class="sk-cube4 sk-cube"></div>
					<div class="sk-cube3 sk-cube"></div>
				</div>
			</div>
		</div>

		<div class="form-group">
			<div class="card">
				<div class="card-title">
					<h2>Customer Management</h2>
				</div>
				<p-messages [escape]="true" [value]="msgs"></p-messages>
				<div class="cont">
					<div class="group" sec:authorize="hasAuthority('customer_management')">
						<div class="collapse-title"
							(click)="ele.class = ele.class == 'hideChildren' ? '' :  'hideChildren'">Customer Management
							<i class="collapse-icon fa"
								[ngClass]=" ele.class !== 'hideChildren' ? 'fa-minus' : 'fa-plus'"></i>
						</div>
						<div class="collapse in show" id="customerManagementGroup"
							[ngClass]="{ hideChildren : ele.class == 'hideChildren' }" #ele>
							<div class="group-cont">

								<div class="table-responsive">
									<p-table #dt class="table" styleClass="ui-table-customers"
										tableStyleClass="table table-respnsive" [value]="customersList"
										totalRecords="{{customersList.length}}" [rows]="11"
										[showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]"
										[paginator]="true"
										currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

										<ng-template pTemplate="header">
											<tr>
												<th pSortableColumn="email" width="12%">Email<p-sortIcon
														field="email"></p-sortIcon></th>

												<th pSortableColumn="customerNumber" width="12%">Number<p-sortIcon
														field="customerNumber"></p-sortIcon></th>
												<th pSortableColumn="customerName" width="12%">Name<p-sortIcon
														field="customerName"></p-sortIcon></th>

												<th pSortableColumn="customerGroupName" width="12%">Group<p-sortIcon
														field="customerGroupName"></p-sortIcon></th>

												<th pSortableColumn="sector.sector" width="12%">Sector<p-sortIcon
														field="sector.sector"></p-sortIcon></th>

												<th pSortableColumn="region.region" width="12%">Region<p-sortIcon
														field="region.region"></p-sortIcon></th>
												<th pSortableColumn="contactPersonName" width="12%">Contact Person
													Name<p-sortIcon field="contactPersonName"></p-sortIcon></th>
												<th pSortableColumn="mobileNumber" width="12%">Mobile Number<p-sortIcon
														field="mobileNumber"></p-sortIcon></th>
												<th colspan="2" width="5%" class="text-center"><span class="add"
														style="cursor: pointer;"><i class="la la-plus"
															(click)="openCustomerDialog($event)"></i></span></th>
											</tr>
											<tr>
												<th><input class="textfilter" pInputText type="text"
														placeholder="Search by Email"
														(input)="dt.filter($event.target.value, 'email', 'contains')">
												</th>
												<th><input class="textfilter" pInputText type="text"
														placeholder="Search by Customer Number"
														(input)="dt.filter($event.target.value, 'customerNumber', 'contains')">
												</th>
												<th><input class="textfilter" pInputText type="text"
														placeholder="Search by Name"
														(input)="dt.filter($event.target.value, 'customerName', 'contains')">
												</th>
												<th><input class="textfilter" pInputText type="text"
														placeholder="Search by Group"
														(input)="dt.filter($event.target.value, 'customerGroupName', 'contains')">
												</th>
												<th>
													<!--<input pInputText type="text" (input)="dt.filter($event.target.value, 'sector.sector', 'contains')">-->
													<!-- <p-dropdown class="dropdownfilter" [options]="sectors"

														defaultLabel=" " placeholder="Search by Sector"
														[showClear]="true"
														optionLabel="label" optionValue="value"
														(onChange)="dt.filter($event.value, 'sector.sector', 'equals')"></p-dropdown> -->

													<p-dropdown class="dropdownfilter" [options]="sectors"
														placeholder="Search by Sector" [showClear]="true"
														optionLabel="label" optionValue="value"
														(onChange)="dt.filter($event.value, 'sector.sector', 'equals')">
													</p-dropdown>

												</th>
												<th><input class="textfilter" pInputText type="text"
														placeholder="Search by Group"
														(input)="dt.filter($event.target.value, 'customerGroupName', 'contains')">
												</th>

												<th>
													<!--<input class="textfilter" pInputText type="text" (input)="dt.filter($event.target.value, 'region.region', 'contains')"> -->
													<p-dropdown class="dropdownfilter" [options]="regions"
														defaultLabel=" " placeholder="Search by Region"
														[showClear]="true" optionLabel="label" optionValue="value"
														(onChange)="dt.filter($event.value, 'region.region', 'equals')"></p-dropdown>
												</th>
												<th><input class="textfilter" pInputText type="text"
														placeholder="Search by Contact Name"
														(input)="dt.filter($event.target.value, 'contactPersonName', 'contains')">
												</th>
												<th><input class="textfilter" pInputText type="text"
														placeholder="Search by Mobile Number"
														(input)="dt.filter($event.target.value, 'mobileNumber', 'contains')">
												</th>
												<th></th>
												<th></th>
											</tr>

										</ng-template>
										<ng-template pTemplate="body" let-userrow let-expanded="expanded">
											<tr (dblclick)="editUserData(userrow.customerId)">
												<td class="year">{{userrow.email}}</td>
												<td>{{userrow.customerNumber}}</td>
												<td>{{userrow.customerName}}</td>
												<td>{{userrow.customerGroupName}}</td>
												<td>{{userrow.sector.sector}}</td>
												<td>{{userrow.region.region}}</td>
												<td>{{userrow.contactPersonName}}</td>
												<td>{{userrow.mobileNumber}}</td>
												<td class="options">
													<ul>
														<li>
															<div class="delete text-red"><i style="cursor: pointer;"
																	class="la la-trash"
																	(click)="onDeleteCustomer(userrow.customerId)"></i>
															</div>
														</li>
													</ul>
												</td>
											</tr>
										</ng-template>
									</p-table>
								</div>
							</div>
							<!-- /.group-cont -->
						</div>
					</div>
				</div>
			</div>

			<p-dialog [header]="addEditUserHeader" [visible]="displayDialog" [modal]="true" width="500" height="600"
				[resizable]="false" [closable]="false">


				<table class="table editable" id="user-table" width="100%">
					<thead>

						<tr>
							<th class="empIduser">Email</th>
							<th class="firstNameuser">Customer Number</th>
							<th class="lastNameuser">Customer Name</th>
							<th class="customerGroupName">Customer Group</th>

							<th class="emailuser">Sector</th>
							<th class="Manageruser">Region</th>
							<th class="quotauser">Contact Person</th>
							<th class="roleuser">Mobile Number</th>
							<th class="BrandLeadItemsuser"></th>
						</tr>
					</thead>
					<tr height="110px">
						<td style="vertical-align: top;">
							<input type="text" id="email" name="email" required formControlName="email"
								[(ngModel)]="customerDTO.email" class="input">
							<div *ngIf="myGroup.controls['email'].invalid && (myGroup.controls['email'].dirty || myGroup.controls['email'].touched)"
								class="alert alert-danger">
								<div *ngIf="myGroup.controls['email'].errors.required">
									Email is required.
								</div>
								<div *ngIf="myGroup.controls['email'].errors.sector">
									Invalid Email.
								</div>
							</div>
						</td>
						<td style="vertical-align: top;">
							<input type="text" id="customerNumber" name="customerNumber" required
								formControlName="customerNumber" [(ngModel)]="customerDTO.customerNumber" class="input">
							<div *ngIf="myGroup.controls['customerNumber'].invalid && (myGroup.controls['customerNumber'].dirty || myGroup.controls['customerNumber'].touched)"
								class="alert alert-danger">
								<div *ngIf="myGroup.controls['customerNumber'].errors.required">
									Customer Number is required.
								</div>
							</div>
						</td>

						<td style="vertical-align: top;">
							<input type="text" id="customerName" name="customerName" required
								formControlName="customerName" [(ngModel)]="customerDTO.customerName" class="input">
							<div *ngIf="myGroup.controls['customerName'].invalid && (myGroup.controls['customerName'].dirty || myGroup.controls['customerName'].touched)"
								class="alert alert-danger">
								<div *ngIf="myGroup.controls['customerName'].errors.required">
									Customer Name is required.
								</div>
							</div>
						</td>


						<td style="vertical-align: top;">
							<input type="text" id="customerGroupName" name="customerGroupName" required
								formControlName="customerGroupName" [(ngModel)]="customerDTO.customerGroupName"
								class="input">
							<div *ngIf="myGroup.controls['customerGroupName'].invalid && (myGroup.controls['customerGroupName'].dirty || myGroup.controls['customerGroupName'].touched)"
								class="alert alert-danger">
								<div *ngIf="myGroup.controls['customerGroupName'].errors.required">
									Customer Name is required.
								</div>
							</div>
						</td>

						<td style="vertical-align: top;">
							<select name="sector" class="input" id="sector" required formControlName="sector"
								[(ngModel)]="customerDTO.sector.sectorId">
								<option id="-1" selected default="yes" [ngValue]="null" value="null">Sector</option>
								<option *ngFor="let sector of sectorList; let i = index" [value]="sector?.sectorId">
									{{sector?.sector}}
								</option>
							</select>
							<div *ngIf="myGroup.controls['sector'].invalid && (myGroup.controls['sector'].dirty || myGroup.controls['sector'].touched)"
								class="alert alert-danger">
								<div *ngIf="myGroup.controls['sector'].errors.required">
									Sector is required.
								</div>

							</div>
						</td>
						<td style="vertical-align: top;">
							<select name="region" class="input" id="region" required formControlName="region"
								[(ngModel)]="customerDTO.region.regionId">
								<option id="-1" selected default="yes" [ngValue]="null" value="null">Region</option>
								<option *ngFor="let region of regionsList; let i = index" [value]="region?.regionId">
									{{region?.region}}
								</option>
							</select>
							<div *ngIf="myGroup.controls['region'].invalid && (myGroup.controls['region'].dirty || myGroup.controls['region'].touched)"
								class="alert alert-danger">
								<div *ngIf="myGroup.controls['region'].errors.required">
									Region is required.
								</div>
							</div>
						</td>
						<td style="vertical-align: top;">
							<input type="text" id="contactPerson" name="contactPerson" required
								formControlName="contactPerson" [(ngModel)]="customerDTO.contactPersonName"
								class="input">
							<div *ngIf="myGroup.controls['contactPerson'].invalid && (myGroup.controls['contactPerson'].dirty || myGroup.controls['contactPerson'].touched)"
								class="alert alert-danger">
								<div *ngIf="myGroup.controls['contactPerson'].errors.required">
									Contact Person is required.
								</div>
							</div>
						</td>
						<td style="vertical-align: top;">
							<input type="text" id="mobile" name="mobile" required formControlName="mobile"
								[(ngModel)]="customerDTO.mobileNumber" class="input">
							<div *ngIf="myGroup.controls['mobile'].invalid && (myGroup.controls['mobile'].dirty || myGroup.controls['mobile'].touched)"
								class="alert alert-danger">
								<div *ngIf="myGroup.controls['mobile'].errors.required">
									Mobile is required.
								</div>
							</div>
						</td>
						<td class="options" style="vertical-align: top;">
							<ul class="actions">
								<li class="confirm">
									<!--<i class="la la-check commit" id="x1" onclick="myForm.submit();"></i>-->
									<button id="finish" style="background-color: #36D9B0;border: 0;color: white;"><i
											class="la la-check commit" id="x1"></i></button>
								</li>
								<li class="cancel">
									<i class="la la-close" (click)="closeDialog($event)"></i>
								</li>
							</ul>
						</td>
					</tr>
				</table>
			</p-dialog>
		</div>
	</section>
</form>
